import { createSlice } from "@reduxjs/toolkit";
const initialVal = {
    activeCamera: 0,
    ratio: "alternativeAspectRatio",
    showParkingGrid: true,
};
export const setActiveCameraSlice = createSlice({
    name: "activeCamera",
    initialState: {
        value: initialVal,
    },
    reducers: {
        setActiveCamera: (state, action) => {
            state.value.activeCamera = action.payload;
        },
        setCamerasRatio: (state, action) => {
            state.value.ratio = action.payload;
        },
        setShowParkingGrid: (state, action) => {
            state.value.showParkingGrid = action.payload;
        },
    },
});
export const { setActiveCamera, setCamerasRatio, setShowParkingGrid } = setActiveCameraSlice.actions;
export default setActiveCameraSlice.reducer;
